let appId = "wx014c360d9c40c740";
let isRegisted = false;
import apiUtil from "@/api/request";
import env from "./env";
import wx from "weixin-js-sdk";
import { Toast } from "@vant/compat";
import logger from "@/global/logger.js";

const registWx = async function () {
  try {
    if (!env.isWxEnv) {
      return;
    }

    var requestUrl = window.location.href.split("#")[0];
    logger.info(requestUrl);
    var protocolStr = document.location.protocol;

    var queryObj = {
      appId: appId,
      requestDomain: requestUrl,
    };
    var result = await apiUtil.apiPost("/Weixin/GetJssdkSignature", queryObj);

    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: appId, // 必填，公众号的唯一标识
      timestamp: result.timestamp, // 必填，生成签名的时间戳
      nonceStr: result.nonceStr, // 必填，生成签名的随机串
      signature: result.signature, // 必填，签名
      jsApiList: [
        "checkJsApi",
        "scanQRCode",
        "chooseImage",
        "previewImage",
        "uploadImage",
        "downloadImage",
        "getLocalImgData",
      ],
      success: function () {
        logger.debug("调用成功");
      },
      fail: function (error) {
        logger.debug(error);
      },
    });
  } catch (error) {
    logger.debug("get error: " + error);
  }
};

function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

// 添加刷新缓存的方法
const refreshCache = function () {
  if (env.isWxEnv) {
    // 添加时间戳参数来强制刷新
    const timestamp = new Date().getTime();
    const currentUrl = window.location.href;
    const newUrl = currentUrl.includes("?")
      ? `${currentUrl}&t=${timestamp}`
      : `${currentUrl}?t=${timestamp}`;
    window.location.replace(newUrl);
  }
};

const ConfigIsWxEnv = function () {
  console.debug("Judge if Wxapp env");
  if (!isWeiXin()) {
    env.isWxEnv = false;
    env.isWxAppEnv = false;
    logger.debug("Is not Wx Env");
  } else {
    env.isWxEnv = true;
    logger.debug("Is Wx Env");
  }

  //微信API获取当前运行环境
  wx.miniProgram.getEnv((res) => {
    //registWx();
    if (res.miniprogram) {
      //小程序环境
      env.isWxAppEnv = true;
    } else {
      env.isWxAppEnv = false;
    }
  });
};

export default {
  appId,
  registWx,
  ConfigIsWxEnv,
  refreshCache,
};

// onMenuShareTimeline
// onMenuShareAppMessage
// onMenuShareQQ
// onMenuShareWeibo
// onMenuShareQZone
// startRecord
// stopRecord
// onVoiceRecordEnd
// playVoice
// pauseVoice
// stopVoice
// onVoicePlayEnd
// uploadVoice
// downloadVoice
// chooseImage
// previewImage
// uploadImage
// downloadImage
// translateVoice
// getNetworkType
// openLocation
// getLocation
// hideOptionMenu
// showOptionMenu
// hideMenuItems
// showMenuItems
// hideAllNonBaseMenuItem
// showAllNonBaseMenuItem
// closeWindow
// scanQRCode
// chooseWXPay
// openProductSpecificView
// addCard
// chooseCard
// openCard
